<div *ngIf="!isInMaintenanceMode">
<mat-sidenav-container fullscreen class="mat-typography page-background">
  <mat-sidenav-content fxFlexFill class="mat-drawer-content" id="contentStart">
    <app-page-header></app-page-header>
    <div
      class="page-content"
      [ngClass]="{
        'xxpage-content-top-one-row': media.isActive('gt-xs') && !isNavigationTwoRows,
        'xxpage-content-top-two-rows': media.isActive('gt-xs') && isNavigationTwoRows,
        'xxpage-content-top-one-row-xs': media.isActive('xs') && !isNavigationTwoRows,
        'xxpage-content-top-two-rows-xs': media.isActive('xs') && isNavigationTwoRows
      }"
    >
      <router-outlet></router-outlet>
      <app-page-footer></app-page-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
</div>

<div *ngIf="isInMaintenanceMode">
  <router-outlet></router-outlet>
</div>
